import { createSlice, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getBidsList } from './actionCreators';
import { BIDDING_SLICE_NAME, BiddingState, initialState } from './models';

export const slice = createSlice({
  name: BIDDING_SLICE_NAME,
  initialState,
  reducers: {
    resetBiddingState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBidsList.pending, (state: BiddingState, action) => {
        const { propertyId, cursor } = action.meta.arg;

        // A request for another property invalidates whatever is in the store.
        if (state.propertyId !== propertyId) {
          state.bidsList = null;
        }

        state.propertyId = propertyId;
        state.isLoading = true;
        state.error = null;

        if (!cursor) {
          state.bidsList = null;
        }
      })
      .addCase(getBidsList.fulfilled, (state: BiddingState, action) => {
        const { payload, meta } = action;
        const { propertyId, cursor } = meta.arg;

        // Drop responses that belong to a property we are no longer showing.
        if (state.propertyId !== propertyId) {
          return;
        }

        state.isLoading = false;
        state.error = null;

        const items = cursor ? [...(state.bidsList?.items ?? []), ...(payload.items ?? [])] : payload.items ?? [];

        state.bidsList = {
          ...payload,
          items,
        };
      })
      .addMatcher(isRejected(getBidsList), (state: BiddingState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default slice.reducer;
export const { resetBiddingState } = slice.actions;
export { BIDDING_SLICE_NAME } from './models';
